import React from "react";
import Commandes from "../../compo/Commnades";

export default function Cmd_art(){
  const service='_cmd.php'
  return(
      <Commandes service={service} do='art'/>
  )
}